export default "__VITE_ASSET__ByQV6vjn__"